"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCart = exports.trackCatalog = void 0;
const memoize_1 = __importDefault(require("lodash/memoize"));
const libs_tracking_events_1 = require("@hotelplan/libs.tracking-events");
const toTrackId = ({ type, id }) => `${type}_${id}`;
const trackCatalogOrder = (action) => (0, libs_tracking_events_1.track)({
    event: action.type,
    _clear: true,
    eventMetadata: action.payload,
});
// CATALOGS
var ECatalogsEventType;
(function (ECatalogsEventType) {
    ECatalogsEventType["ADD"] = "\uD83D\uDE80 catalog.add";
    ECatalogsEventType["REMOVE"] = "\uD83D\uDE80 catalog.remove";
    ECatalogsEventType["VIEW"] = "\uD83D\uDE80 catalog.view";
    ECatalogsEventType["DOWNLOAD"] = "\uD83D\uDE80 catalog.download";
})(ECatalogsEventType || (ECatalogsEventType = {}));
const catalogPayload = ({ type, id }, position) => {
    return { id: toTrackId({ id, type }), position: `${position}` };
};
const trackCatalogActions = (payload) => ({
    add() {
        trackCatalogOrder({ type: ECatalogsEventType.ADD, payload });
    },
    remove() {
        trackCatalogOrder({ type: ECatalogsEventType.REMOVE, payload });
    },
    view() {
        trackCatalogOrder({ type: ECatalogsEventType.VIEW, payload });
    },
    download() {
        trackCatalogOrder({ type: ECatalogsEventType.DOWNLOAD, payload });
    },
});
exports.trackCatalog = (0, memoize_1.default)((catalog, position) => {
    const payload = catalogPayload(catalog, position);
    return trackCatalogActions(payload);
}, (catalog, position) => `${position}_${catalog.type}_${catalog.id}`);
// CART
var ECartEventType;
(function (ECartEventType) {
    ECartEventType["CART"] = "\uD83D\uDE80 catalog.cart";
    ECartEventType["ORDER"] = "\uD83D\uDE80 catalog.order";
})(ECartEventType || (ECartEventType = {}));
const trackCart = (list) => {
    const ids = list.map(toTrackId);
    return {
        cart() {
            trackCatalogOrder({ type: ECartEventType.CART, payload: { ids } });
        },
        order() {
            trackCatalogOrder({ type: ECartEventType.ORDER, payload: { ids } });
        },
    };
};
exports.trackCart = trackCart;
//# sourceMappingURL=trackCatalogOrder.js.map